import {IntermediatePart} from "../../intermediatePart";
import Cabinet from "../../parts/cabinet";
import {LayoutAbbreviations} from "../../constants";
import {IS_LIXIL_UI} from "../../../../../config";
import Appliance from "../../parts/appliance";

export default class Backsplash extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'backsplash';
    this.partName = 'Backsplash';
    this.translateId = "visualizer.kitchen.walls.backsplash";
    this.isStoneFeature = true;
    this.allWallsCanBeApplied = true;
    if (isChild) {
      this.nextFeaturesPageToLoadArray = {};
      LayoutAbbreviations.forEach(layoutAbbreviation => {
        this.nextFeaturesPageToLoadArray[layoutAbbreviation] = {
          page: 0,
          allReceived: false,
        };
      });
    }
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Backsplash());
  }

  alreadyAddedIndex(featureList, name) {
    return featureList.findIndex(feature => feature.getSplittedFeatureName() === name)
  }

  getBacksplashNavItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let availableFeatures = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(true), filteredAvailableFeatures);
    let featuresToDisplay = [];
    const activeType = this.getFeatureBacksplashType(this.activeFeature);
    let cabinetLayoutMetaData = null;
    if (this.activeFeature && this.featureIsFullWall(this.activeFeature)) { // full backsplashes should be filtered by CabinetLayout metaData
      const cabinetParent = this.getParent().layout.parts[Cabinet.id];
      cabinetLayoutMetaData = cabinetParent && cabinetParent.topCabinet && cabinetParent.topCabinet.activeFeature
        && cabinetParent.topCabinet.activeFeature.metaData && cabinetParent.topCabinet.activeFeature.metaData["CabinetLayout"];
    }
    for (let feature of availableFeatures) {
      const currentName = feature.getSplittedFeatureName();
      if (feature.notAvailableInVisualizer) {
        continue;
      }
      const alreadyAddedFeatureIndex = this.alreadyAddedIndex(featuresToDisplay, currentName);
      const matchByType = !activeType || (this.getFeatureBacksplashType(feature) === activeType);
      const matchByCabLayout = !cabinetLayoutMetaData || (feature.metaData && feature.metaData["CabinetLayout"]
        && feature.metaData["CabinetLayout"].includes(cabinetLayoutMetaData[0]));

      if (IS_LIXIL_UI) {
        if (alreadyAddedFeatureIndex > -1) {
          if (matchByType && matchByCabLayout) {
            featuresToDisplay.splice(alreadyAddedFeatureIndex, 1, feature);
          }
        } else {
          featuresToDisplay.push(feature);
        }
      } else if ((alreadyAddedFeatureIndex === -1) && matchByType && matchByCabLayout) {
        featuresToDisplay.push(feature);
      }
    }
    return featuresToDisplay
  }

  navigationSubItems(filters, searchText) {
    const featuresToDisplay = this.getBacksplashNavItems(filters, searchText);
    return this.returnUniqueNavFeatures(featuresToDisplay);
  }

  getFeatureByBacksplashType(neededType, featureName = "", sameNameOnly = false) {
    const conditions = this.getArrayOfConditions();
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(conditions);
    const matchingFeatures = featuresToDisplay.filter(feature => this.getFeatureBacksplashType(feature) === neededType);

    let currentPartName = featureName;
    if (!currentPartName && this.activeFeature) {
      currentPartName = this.activeFeature.getSplittedFeatureName();
    }

    const matchByName = matchingFeatures.filter(feature => {
      return feature.getSplittedFeatureName() === currentPartName
    });
    if (matchByName.length > 1) {
      const cabinetLayoutMetaData = this.getTopCabinetCabinetLayoutMetadata();
      const sameCabinetType = matchByName.find(feature => {
        if (this.featureIsFullWall(feature)) {
          return feature.matchesMetaForArrayOfConditions([
            {
              propName: 'CabinetLayout',
              propValue: cabinetLayoutMetaData
            }
          ])
        }
      });
      return sameCabinetType || matchByName[0];
    }
    if (sameNameOnly) {
      return matchByName[0]
    }
    return matchByName[0] || matchingFeatures[0];
  }

  featureIsFullWall(feature) {
    return this.getFeatureBacksplashType(feature) === "Full"
  }

  getFeatureBacksplashType(feature) {
    return feature && Array.isArray(feature.metaData["BacksplashType"]) ? feature.metaData["BacksplashType"][0] : null
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const applianceParent = this.getParent().layout.parts[Appliance.id];
    // remove FullWall backsplashes if yes is passed // more logic in matchesMetaForCondition func
    conditions.push({
      propName: "RemoveFullWallFeatures",
      propValue: applianceParent && applianceParent.hood && !applianceParent.hood.disabled
        && applianceParent.hood.activeFeature
        && applianceParent.hood.activeFeature.metaData
        && applianceParent.hood.activeFeature.metaData["HoodHeight"]
        && (applianceParent.hood.activeFeature.metaData["HoodHeight"].includes("Full")
        || applianceParent.hood.activeFeature.metaData["HoodHeight"].includes("FullWall")) ? "No" : "Yes",
    });
    return conditions
  }

  getCurrentActiveFeatureType() {
    if (this.disabled) {
      return "No Backsplash"
    }
    return this.getFeatureBacksplashType(this.activeFeature)
  }

  // setFeatureByName = async () => {
  //   window.requestInProcess = true;
  //   loaderEnable();
  //   const splittedName = this.activeFeature.getSplittedFeatureName();
  //   await Navigation.searchFeaturesByName(this, splittedName);
  //   const neededFeature = this.findFeatureByPartName(splittedName, true);
  //   if (neededFeature) {
  //     this.activeFeature = neededFeature;
  //   }
  //   window.requestInProcess = false;
  //   loaderDisable();
  //   $(window).trigger(ActionTypes.CHANGE_LAYOUT); // update canvas
  // };

  getTopCabinetCabinetLayoutMetadata() {
    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    return cabinetParent && cabinetParent.topCabinet && cabinetParent.topCabinet.activeFeature
      && cabinetParent.topCabinet.activeFeature.metaData && cabinetParent.topCabinet.activeFeature.metaData["CabinetLayout"];
  }
}
